import {FC, useState} from 'react';
import {useRecoilState, useRecoilStateLoadable, useRecoilValue} from 'recoil';
import {Box, Drawer} from '@mui/material';
import Fallback from '../../../../ui/fallback/Fallback';
import {EditDeviceModel} from './EditDeviceModel';
import {AddDeviceModel} from './AddDeviceModel';
import {deviceModelControlModeState, deviceModelControlState} from '../../../../store/deviceModels/atoms';
import {deviceTypesDictQuery} from '../../../../store/deviceTypes/selectors';
import {LoadableHelpers} from '../../../../shared/helpers/loadableHelpers';

export const DeviceModelControl: FC = () => {
  const [open, setOpen] = useRecoilState(deviceModelControlState);
  const [loading, setLoading] = useState(false);
  const mode = useRecoilValue(deviceModelControlModeState);
  const [loadable] = useRecoilStateLoadable(deviceTypesDictQuery);
  const deviceTypes = LoadableHelpers.withDefaultPageable(loadable, []);

  const handleClose = () => {
    if (loading) return;
    setOpen(false);
  };

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <Box sx={{width: '662px', p: 3, height: '100%'}} role="presentation">
        {loading ? (
          <Fallback />
        ) : mode === 'ADD' ? (
          <AddDeviceModel
            loading={loading}
            setLoading={setLoading}
            handleClose={handleClose}
            deviceTypes={deviceTypes}
          />
        ) : mode === 'EDIT' ? (
          <EditDeviceModel
            loading={loading}
            setLoading={setLoading}
            handleClose={handleClose}
            deviceTypes={deviceTypes}
          />
        ) : null}
      </Box>
    </Drawer>
  );
};
